import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import { useViewInfoProduct } from "@/Service/Api/Index";
import type { Price } from "@/Type/Price";
import React, { useCallback, useContext, useState } from "react";
import { useParams } from "react-router-dom";

type ProductContextType = {
  Products: ProductByIdPdp[];
  isLoading: boolean;
  Categories?: string;
  SubCategories?: string;
  AddQuantity: (count: number) => void;
  Quantitys: Price;
  OpenModal: boolean;
  HeadlessOpenModal: () => void;
};

export const ProductContext = React.createContext<
  ProductContextType | undefined
>(undefined);

type paramCategory = { c?: string };
type paramSubCategory = { subcategory?: string };
type paramSku = { idSku?: string };

export const ContextProductProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { c } = useParams<paramCategory>();
  const { subcategory } = useParams<paramSubCategory>();
  const { idSku } = useParams<paramSku>();
  const { mDatos: Productos, isLoading } = useViewInfoProduct(
    idSku!,
    c!,
    "subcategoria"
  );
  const [Quantity, setQuantity] = useState<number>(0);
  const [OpenModal, setOpenModal] = useState<boolean>(false);

  const Products = Productos.length > 0 ? Productos : [];
  const Categories = c!;
  const SubCategories = subcategory!;
  const Quantitys = Quantity;

  const AddQuantity = useCallback((count: number) => {
    setQuantity(count);
  }, []);

  const HeadlessOpenModal = useCallback(() => {
    setOpenModal((prev) => !prev);
  }, []);

  return (
    <ProductContext.Provider
      value={{
        Products,
        isLoading,
        Categories,
        SubCategories,
        AddQuantity,
        Quantitys,
        OpenModal,
        HeadlessOpenModal,
      }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useContextProductData = () => {
  const context = useContext(ProductContext);
  if (!context)
    throw new Error(
      "useContextProductData must be used within a ContextProductProvider"
    );

  return context;
};
